import React, { Fragment } from 'react'

import PropTypes from 'prop-types'
import wtsapp from './wtsapp.png'
import './cta26.css'

const CTA26 = (props) => {
  return (
    <div className="thq-section-padding">
      <div className="thq-section-max-width">
        <div className="cta26-accent2-bg">
          <div className="cta26-accent1-bg">
            <div className="cta26-container2">
              <div className="cta26-content">
                <span>
                  {props.heading1 ?? (
                    <Fragment>
                      <span className="cta26-text4 thq-heading-2">
                        Book an Appointment Today
                      </span>
                    </Fragment>
                  )}
                </span>
                <p>
                  {props.content1 ?? (
                    <Fragment>
                      <p className="cta26-text5 thq-body-large">
                        Don&apos;t wait, take the first step towards better
                        Mental health.
                      </p>
                    </Fragment>
                  )}
                </p>
              </div>
              <div className="cta26-actions">
                <button
                  type="button"
                  className="thq-button-filled cta26-button"
                >
                  {/* <span>
                    {props.action1 ?? (
                      <Fragment>
                        <span className="cta26-text6">
                          Call Now: 9048337334
                        </span>
                      </Fragment>
                    )}
                  </span> */}
                  <span>
                    {props.action1 ?? (
                      <Fragment>
                        <span className="cta26-text6">
                          Call Now:
                          <a href="tel:9048337334" className="call-link">9048337334</a>
                        </span>
                        <span className="whatsapp-container" style={{ marginLeft: "10px" }}>
                        <img
                              src={wtsapp} // Replace with the path to your WhatsApp icon image
                              alt="WhatsApp"
                              className="whatsapp-icon"
                              style={{ width: "50px", height: "50px" }} // Customize icon size
                            />
                          <a
                            href="https://wa.me/9048337334"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="whatsapp-link"
                          >

                          </a>
                        </span>
                      </Fragment>
                    )}
                  </span>

                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

CTA26.defaultProps = {
  heading1: undefined,
  content1: undefined,
  action1: undefined,
}

CTA26.propTypes = {
  heading1: PropTypes.element,
  content1: PropTypes.element,
  action1: PropTypes.element,
}

export default CTA26
